const MUTE_KEY = 'playing.soundMuted';

export function isPlayingMuted() {
  try {
    return localStorage.getItem(MUTE_KEY) === '1';
  } catch {
    return false;
  }
}

export function setPlayingMuted(muted) {
  try {
    localStorage.setItem(MUTE_KEY, muted ? '1' : '0');
  } catch {
    /* ignore */
  }
}

let audioCtx;

function getCtx() {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!audioCtx) audioCtx = new AC();
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {});
  }
  return audioCtx;
}

function tone(freq, durationSec, type = 'sine', volume = 0.05) {
  if (isPlayingMuted()) return;
  const ctx = getCtx();
  if (!ctx) return;
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.value = volume;
    osc.connect(gain);
    gain.connect(ctx.destination);
    const t = ctx.currentTime;
    gain.gain.setValueAtTime(volume, t);
    gain.gain.exponentialRampToValueAtTime(0.001, t + durationSec);
    osc.start(t);
    osc.stop(t + durationSec + 0.02);
  } catch {
    /* ignore */
  }
}

/** Soft chess-site style cues via Web Audio (no asset files). */
export function playChessCue(kind) {
  switch (kind) {
    case 'capture':
      tone(210, 0.09, 'triangle', 0.06);
      break;
    case 'check':
      tone(880, 0.08, 'square', 0.035);
      setTimeout(() => tone(660, 0.1, 'square', 0.03), 70);
      break;
    case 'end':
      tone(523, 0.12, 'sine', 0.05);
      setTimeout(() => tone(392, 0.2, 'sine', 0.045), 110);
      break;
    case 'offer':
      tone(640, 0.07, 'triangle', 0.045);
      setTimeout(() => tone(780, 0.12, 'triangle', 0.04), 90);
      break;
    case 'tick':
      tone(920, 0.035, 'square', 0.028);
      break;
    case 'move':
    default:
      tone(460, 0.045, 'sine', 0.04);
      break;
  }
}
